export const defaultTheme = {
  colors: {
    red: {
      1: "#fff1f0",
      2: "#ffccc7",
      3: "#ffa39e",
      4: "#ff7875",
      5: "#ff4d4f",
      6: "#f5222d",
      7: "#cf1322",
      8: "#a8071a",
      9: "#820014",
      10: "#5c0011"
    },
    rose: {
      1: "#fff0f6",
      2: "#ffd6e7",
      3: "#ffadd2",
      4: "#ff85c0",
      5: "#f759ab",
      6: "#eb2f96",
      7: "#c41d7f",
      8: "#9e1068",
      9: "#780650",
      10: "#520339"
    },
    coral: {
      1: "#fff2f0",
      2: "#ffd8cc",
      3: "#ffb3a3",
      4: "#ff8f7a",
      5: "#f86f4e",
      6: "#eb4d28",
      7: "#c7381a",
      8: "#a32b13",
      9: "#7f1f0d",
      10: "#5c1508"
    },
    orange: {
      1: "#fff7e6",
      2: "#ffe7ba",
      3: "#ffd591",
      4: "#ffc069",
      5: "#ffa940",
      6: "#fa8c16",
      7: "#d46b08",
      8: "#ad4e00",
      9: "#873800",
      10: "#612500"
    },
    volcano: {
      1: "#fff2e8",
      2: "#ffd8bf",
      3: "#ffbb96",
      4: "#ff9c6e",
      5: "#ff7a45",
      6: "#fa541c",
      7: "#d4380d",
      8: "#ad2102",
      9: "#871400",
      10: "#610b00"
    },
    apricot: {
      1: "#fff9f0",
      2: "#ffe3c2",
      3: "#ffce9c",
      4: "#ffb875",
      5: "#ffa14f",
      6: "#f58a2e",
      7: "#cc6c19",
      8: "#a3560f",
      9: "#7a4008",
      10: "#522b03"
    },
    yellow: {
      1: "#feffe6",
      2: "#ffffb8",
      3: "#fffb8f",
      4: "#fff566",
      5: "#ffec3d",
      6: "#fadb14",
      7: "#d4b106",
      8: "#ad8b00",
      9: "#876800",
      10: "#614700"
    },
    gold: {
      1: "#fffbe6",
      2: "#fff1b8",
      3: "#ffe58f",
      4: "#ffd666",
      5: "#ffc53d",
      6: "#faad14",
      7: "#d48806",
      8: "#ad6800",
      9: "#874d00",
      10: "#613400"
    },
    amber: {
      1: "#fff8e1",
      2: "#ffecb3",
      3: "#ffe082",
      4: "#ffd54f",
      5: "#ffca28",
      6: "#ffc107",
      7: "#ffa000",
      8: "#ff8f00",
      9: "#ff6f00",
      10: "#e65100"
    },
    green: {
      1: "#f6ffed",
      2: "#d9f7be",
      3: "#b7eb8f",
      4: "#95de64",
      5: "#73d13d",
      6: "#52c41a",
      7: "#389e0d",
      8: "#237804",
      9: "#135200",
      10: "#092b00"
    },
    lime: {
      1: "#fcffe6",
      2: "#f4ffb8",
      3: "#eaff8f",
      4: "#d3f261",
      5: "#bae637",
      6: "#a0d911",
      7: "#7cb305",
      8: "#5b8c00",
      9: "#3f6600",
      10: "#254000"
    },
    mint: {
      1: "#e6fff9",
      2: "#b5f5ec",
      3: "#87e8de",
      4: "#5cdbd3",
      5: "#36cfc9",
      6: "#13c2c2",
      7: "#08979c",
      8: "#006d75",
      9: "#00474f",
      10: "#002329"
    },
    blue: {
      1: "#e6f4ff",
      2: "#bae0ff",
      3: "#91caff",
      4: "#69b1ff",
      5: "#4096ff",
      6: "#1677ff",
      7: "#0958d9",
      8: "#003eb3",
      9: "#002c8c",
      10: "#001d66"
    },
    sky: {
      1: "#f0fbff",
      2: "#c2f1ff",
      3: "#99e6ff",
      4: "#6fdbff",
      5: "#46d0ff",
      6: "#1ac4ff",
      7: "#009edb",
      8: "#0079b0",
      9: "#005385",
      10: "#002e5a"
    },
    cerulean: {
      1: "#e6faff",
      2: "#b3ecff",
      3: "#80ddff",
      4: "#4dcfff",
      5: "#1ac0ff",
      6: "#00a6e6",
      7: "#0088bf",
      8: "#006a99",
      9: "#004c73",
      10: "#002f4d"
    },
    indigo: {
      1: "#f0f5ff",
      2: "#d6e4ff",
      3: "#adc8ff",
      4: "#84a9ff",
      5: "#6690ff",
      6: "#3366ff",
      7: "#254edb",
      8: "#1939b7",
      9: "#102693",
      10: "#091a7a"
    },
    cobalt: {
      1: "#edf6ff",
      2: "#cce4ff",
      3: "#99c9ff",
      4: "#66adff",
      5: "#338fff",
      6: "#006bff",
      7: "#0054cc",
      8: "#003e99",
      9: "#002966",
      10: "#001433"
    },
    navy: {
      1: "#f0f4f8",
      2: "#d6deea",
      3: "#adc1d8",
      4: "#84a3c6",
      5: "#5b86b4",
      6: "#346aa3",
      7: "#245385",
      8: "#183d66",
      9: "#0f2947",
      10: "#081726"
    },
    purple: {
      1: "#f9f0ff",
      2: "#efdbff",
      3: "#d3adf7",
      4: "#b37feb",
      5: "#9254de",
      6: "#722ed1",
      7: "#531dab",
      8: "#391085",
      9: "#22075e",
      10: "#120338"
    },
    plum: {
      1: "#fbeeff",
      2: "#e7c7f3",
      3: "#d3a0e6",
      4: "#bf79d9",
      5: "#ab52cc",
      6: "#973bb7",
      7: "#752e93",
      8: "#541f6e",
      9: "#39144a",
      10: "#1f0a26"
    },
    orchid: {
      1: "#fef4ff",
      2: "#f5d9f8",
      3: "#ecbef1",
      4: "#e2a3ea",
      5: "#d988e3",
      6: "#d06ddc",
      7: "#a856b2",
      8: "#803f88",
      9: "#58285e",
      10: "#301034"
    },
    forest: {
      1: "#f0f7f0",
      2: "#cce3cc",
      3: "#a6cca6",
      4: "#80b380",
      5: "#5c995c",
      6: "#387f38",
      7: "#2d662d",
      8: "#224c22",
      9: "#173317",
      10: "#0c1a0c"
    },
    sage: {
      1: "#f2f4f1",
      2: "#dde2db",
      3: "#c7cfc4",
      4: "#b1bcad",
      5: "#9ba996",
      6: "#85957f",
      7: "#6f7d69",
      8: "#596553",
      9: "#434d3e",
      10: "#2c3428"
    },
    "warm-gray": {
      1: "#fdfcfa",
      2: "#f5f2ed",
      3: "#e8e3db",
      4: "#d5cdc2",
      5: "#bfb5a7",
      6: "#a69c8d",
      7: "#8c8274",
      8: "#73685c",
      9: "#594f44",
      10: "#40362c"
    },
    "cool-gray": {
      1: "#fbfcfd",
      2: "#f2f4f7",
      3: "#e3e7ed",
      4: "#cfd4dd",
      5: "#b7bfcc",
      6: "#9ea7b8",
      7: "#858fa3",
      8: "#6b758b",
      9: "#515a70",
      10: "#373f52"
    },
    neutral: {
      1: "#ffffff",
      2: "#f5f5f5",
      3: "#e0e0e0",
      4: "#c2c2c2",
      5: "#a3a3a3",
      6: "#858585",
      7: "#666666",
      8: "#4d4d4d",
      9: "#2e2e2e",
      10: "#000000"
    },
    black: {
      1: "#ffffff",
      2: "#f5f5f5",
      3: "#e0e0e0",
      4: "#c2c2c2",
      5: "#a3a3a3",
      6: "#858585",
      7: "#666666",
      8: "#4d4d4d",
      9: "#2e2e2e",
      10: "#000000"
    },
    white: {
      1: "#000000",
      2: "#2e2e2e",
      3: "#4d4d4d",
      4: "#666666",
      5: "#858585",
      6: "#a3a3a3",
      7: "#c2c2c2",
      8: "#e0e0e0",
      9: "#f5f5f5",
      10: "#ffffff"
    }
  },
  body: {
    backgroundColor: "white-10",
    color: "white-2"
  },
  typography: {
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem"
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem"
  },
  shadows: {
    none: "none",
    sm: "0px 0px 4px rgba(0, 0, 0, 0.2)",
    md: "0px 0px 8px rgba(0, 0, 0, 0.25)",
    lg: "0px 0px 12px rgba(0, 0, 0, 0.3)",
    xl: "0px 0px 16px rgba(0, 0, 0, 0.35)"
  },
  borders: {
    radius: {
      none: "0",
      sm: "0.125rem",
      md: "0.25rem",
      lg: "0.5rem",
      xl: "1rem",
      full: "9999px"
    },
    width: {
      thin: "1px",
      normal: "2px",
      thick: "4px"
    },
    style: {
      solid: "solid",
      dashed: "dashed",
      dotted: "dotted",
      double: "double",
      groove: "groove",
      ridge: "ridge",
      inset: "inset",
      outset: "outset",
      none: "none"
    }
  },
  shapes: {
    square: {
      borderRadius: "0",
      padding: "10px"
    },
    circle: {
      borderRadius: "50%",
      aspectRatio: "1/1",
      padding: "10px"
    },
    rounded: {
      borderRadius: "10px",
      padding: "10px"
    },
    capsule: {
      borderRadius: "9999px",
      padding: "10px"
    }
  },
  components: {
    button: {
      default: { bg: "white-10", txt: "neutral-9", border: "neutral-3" },
      sub: { bg: "neutral-2", txt: "neutral-8", border: "neutral-3" },
      disabled: { bg: "neutral-3", txt: "neutral-6", border: "neutral-4" },
      primary: { bg: "blue-6", txt: "white-10", border: "blue-7" },
      secondary: { bg: "neutral-6", txt: "white-10", border: "neutral-7" },
      success: { bg: "forest-6", txt: "white-10", border: "forest-7" },
      warning: { bg: "amber-6", txt: "neutral-9", border: "amber-7" },
      danger: { bg: "red-6", txt: "white-10", border: "red-7" },
      info: { bg: "sky-6", txt: "white-10", border: "sky-7" },
      red: { bg: "red-2", txt: "red-8", border: "red-6" },
      rose: { bg: "rose-2", txt: "rose-8", border: "rose-6" },
      coral: { bg: "coral-2", txt: "coral-8", border: "coral-6" },
      orange: { bg: "orange-2", txt: "orange-8", border: "orange-6" },
      volcano: { bg: "volcano-2", txt: "volcano-8", border: "volcano-6" },
      apricot: { bg: "apricot-2", txt: "apricot-8", border: "apricot-6" },
      yellow: { bg: "yellow-2", txt: "yellow-8", border: "yellow-6" },
      gold: { bg: "gold-2", txt: "gold-8", border: "gold-6" },
      amber: { bg: "amber-2", txt: "amber-8", border: "amber-6" },
      green: { bg: "green-2", txt: "green-8", border: "green-6" },
      lime: { bg: "lime-2", txt: "lime-8", border: "lime-6" },
      mint: { bg: "mint-2", txt: "mint-8", border: "mint-6" },
      blue: { bg: "blue-2", txt: "blue-8", border: "blue-6" },
      sky: { bg: "sky-2", txt: "sky-8", border: "sky-6" },
      cerulean: { bg: "cerulean-2", txt: "cerulean-8", border: "cerulean-6" },
      indigo: { bg: "indigo-2", txt: "indigo-8", border: "indigo-6" },
      cobalt: { bg: "cobalt-2", txt: "cobalt-8", border: "cobalt-6" },
      navy: { bg: "navy-2", txt: "navy-8", border: "navy-6" },
      purple: { bg: "purple-2", txt: "purple-8", border: "purple-6" },
      plum: { bg: "plum-2", txt: "plum-8", border: "plum-6" },
      orchid: { bg: "orchid-2", txt: "orchid-8", border: "orchid-6" },
      forest: { bg: "forest-2", txt: "forest-8", border: "forest-6" },
      sage: { bg: "sage-2", txt: "sage-8", border: "sage-6" },
      "warm-gray": {
        bg: "warm-gray-2",
        txt: "warm-gray-8",
        border: "warm-gray-6"
      },
      "cool-gray": {
        bg: "cool-gray-2",
        txt: "cool-gray-8",
        border: "cool-gray-6"
      },
      ghost: { bg: "transparent", txt: "neutral-7", border: "neutral-3" },
      text: { bg: "transparent", txt: "neutral-7", border: "transparent" }
    },
    etc: {
      hovered: { bg: "neutral-2", txt: "neutral-8" },
      selected: { bg: "sky-1", txt: "sky-8" }
    },
    input: {
      default: { bg: "neutral-1", txt: "neutral-9", border: "neutral-3" },
      focus: { bg: "neutral-1", txt: "neutral-9", border: "blue-5" },
      error: { bg: "neutral-1", txt: "red-5", border: "red-5" },
      disabled: { bg: "neutral-3", txt: "neutral-6", border: "neutral-4" }
    },
    card: {
      default: { bg: "white-10", border: "neutral-3" },
      hover: { bg: "white-10", border: "neutral-4", shadow: "md" }
    },
    breadcrumb: {
      separator: { color: "neutral-5" },
      text: { color: "neutral-6" },
      now: { color: "neutral-9" }
    },

    badge: {
      default: { bg: "neutral-3", txt: "neutral-7" },
      primary: { bg: "blue-1", txt: "blue-7" },
      success: { bg: "forest-1", txt: "forest-7" },
      warning: { bg: "amber-1", txt: "amber-7" },
      danger: { bg: "red-1", txt: "red-7" },
      info: { bg: "sky-1", txt: "sky-7" }
    },

    toast: {
      success: { bg: "blue-6", txt: "white-10", border: "blue-7" },
      warning: { bg: "amber-6", txt: "neutral-9", border: "amber-7" },
      danger: { bg: "red-6", txt: "white-10", border: "red-7" },
      info: { bg: "sky-6", txt: "white-10", border: "sky-7" }
    },

    alert: {
      default: { bg: "neutral-2", txt: "neutral-8", border: "neutral-3" },
      primary: { bg: "blue-1", txt: "blue-8", border: "blue-3" },
      success: { bg: "forest-1", txt: "forest-8", border: "forest-3" },
      warning: { bg: "amber-1", txt: "amber-8", border: "amber-3" },
      danger: { bg: "red-1", txt: "red-8", border: "red-3" },
      info: { bg: "sky-1", txt: "sky-8", border: "sky-3" }
    },

    tag: {
      default: { bg: "neutral-2", txt: "neutral-8", border: "neutral-3" },
      red: { bg: "red-1", txt: "red-8", border: "red-5" },
      rose: { bg: "rose-1", txt: "rose-8", border: "rose-5" },
      coral: { bg: "coral-1", txt: "coral-8", border: "coral-5" },
      orange: { bg: "orange-1", txt: "orange-8", border: "orange-5" },
      volcano: { bg: "volcano-1", txt: "volcano-8", border: "volcano-5" },
      apricot: { bg: "apricot-1", txt: "apricot-8", border: "apricot-5" },
      yellow: { bg: "yellow-1", txt: "yellow-8", border: "yellow-5" },
      gold: { bg: "gold-1", txt: "gold-8", border: "gold-5" },
      amber: { bg: "amber-1", txt: "amber-8", border: "amber-5" },
      green: { bg: "green-1", txt: "green-8", border: "green-5" },
      lime: { bg: "lime-1", txt: "lime-8", border: "lime-5" },
      mint: { bg: "mint-1", txt: "mint-8", border: "mint-5" },
      blue: { bg: "blue-1", txt: "blue-8", border: "blue-5" },
      sky: { bg: "sky-1", txt: "sky-8", border: "sky-5" },
      cerulean: { bg: "cerulean-1", txt: "cerulean-8", border: "cerulean-5" },
      indigo: { bg: "indigo-1", txt: "indigo-8", border: "indigo-5" },
      cobalt: { bg: "cobalt-1", txt: "cobalt-8", border: "cobalt-5" },
      navy: { bg: "navy-1", txt: "navy-8", border: "navy-5" },
      purple: { bg: "purple-1", txt: "purple-8", border: "purple-5" },
      plum: { bg: "plum-1", txt: "plum-8", border: "plum-5" },
      orchid: { bg: "orchid-1", txt: "orchid-8", border: "orchid-5" },
      forest: { bg: "forest-1", txt: "forest-8", border: "forest-5" },
      sage: { bg: "sage-1", txt: "sage-8", border: "sage-5" },
      "warm-gray": {
        bg: "warm-gray-1",
        txt: "warm-gray-8",
        border: "warm-gray-5"
      },
      "cool-gray": {
        bg: "cool-gray-1",
        txt: "cool-gray-8",
        border: "cool-gray-5"
      },
      neutral: { bg: "neutral-1", txt: "neutral-8", border: "neutral-5" }
    }
  }
};
